import React, {useEffect} from "react";
import {Route, Switch, useLocation, useParams} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import _ from "lodash";
import Loader from "../../../../../Loader";
import EditVolume from "./edit/PageGcp";
import RevertVolume from "../common/revert-volume/Content";
import MountVolume from "../common/mount-volume/Content";
import VolumeInfo from "../common/volume-info/Content";
import CreateSnapshotCopy from "../common/create-snapshot/Content";
import DeleteSnapshot from "../common/delete-snapshot/Content";
import {VolumeIcon} from "@netapp/bxp-design-system-react/icons/monochrome";
import {BackToGallery} from "../common/BackToGalleryButton";
import {SimpleHeader, PageLayoutNoFooter} from "../../Page";
import {NotFoundBody} from "../../NotFoundPage";
import querystring from "query-string";

const PageWrapper = ({we, children}) => {
    return (
        <PageLayoutNoFooter>
            <SimpleHeader flavour={"gcp"} title={`Cloud Volumes Services | ${we.name}`}/>
            <BackToGallery/>
            {children}
        </PageLayoutNoFooter>
    )
};

export default ({ we }) => {
    const {volumeId} = useParams();
    const dispatch = useDispatch();
    const location = useLocation();
    const { location: region } = querystring.parse(location.search);
    const volume = useSelector(state => _.get(state, "cvs.volume"));
    const getVolumeError = useSelector(state => _.get(state, "cvs.getVolumeError"));
    const getVolumeResolved = useSelector(state => _.get(state, "cvs.getVolumeResolved"));
    const getVolumeShowError = useSelector(state => _.get(state, "cvs.getVolumeShowError"));

    useEffect(() => {
        dispatch({
            type: `CVS:GCP-GET-VOLUME`,
            payload: { volumeId, region }
        });
        return () => dispatch({
            type: 'CVS:CLEAR-STATE',
            payload: { volume: null, getVolumeResolved: false, getVolumeError: null, getVolumeShowError: false }
        })
    }, [dispatch, volumeId, region]);

    const hideNotification = () => {
        dispatch({
            type: "CVS:CLEAR-STATE",
            payload: { getVolumeShowError: null }
        });
    };

    const renderContent = () => {
        if (getVolumeError) {
            return <PageWrapper we={we}>
                <NotFoundBody
                errorMessage={getVolumeError}
                showError={getVolumeShowError}
                icon={VolumeIcon}
                deleteNotification={hideNotification}
                notFoundText={"Volume Not Found"}/>
            </PageWrapper>
        }

        if (!getVolumeResolved) {
            return <PageWrapper we={we}><Loader/></PageWrapper>
        }

        return (
            <Switch>
                <Route path="/components/cvs/gcp/:accountId/:credentialsId/volumes/:volumeId/edit-volume" exact render={() => <EditVolume volume={volume}/>}/>
                <Route path="/components/cvs/gcp/:accountId/:credentialsId/volumes/:volumeId/info" exact render={() => <PageWrapper we={we}><VolumeInfo volume={volume}/></PageWrapper>}/>
                <Route path="/components/cvs/gcp/:accountId/:credentialsId/volumes/:volumeId/delete-snapshot" exact render={() => <PageWrapper we={we}><DeleteSnapshot volume={volume}/></PageWrapper>}/>
                <Route path="/components/cvs/gcp/:accountId/:credentialsId/volumes/:volumeId/mount-volume" exact render={() => <PageWrapper we={we}><MountVolume volume={volume}/></PageWrapper>}/>
                <Route path="/components/cvs/gcp/:accountId/:credentialsId/volumes/:volumeId/create-snapshot" exact render={() => <PageWrapper we={we}><CreateSnapshotCopy volume={volume}/></PageWrapper>}/>
                <Route path="/components/cvs/gcp/:accountId/:credentialsId/volumes/:volumeId/revert-volume" exact render={() =><PageWrapper we={we}><RevertVolume volume={volume}/></PageWrapper>}/>
            </Switch>
        )
    };

    return renderContent()
};
